import type { ReactNode } from 'react';
import { type FC } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import styled from 'styled-components';

export const ViewOptionsTableRow: FC<{
  contentCell: ReactNode;
  contourCell: ReactNode;
  transparencyCell: ReactNode;
  visibilityCell: ReactNode;
  testId?: string;
  hover?: boolean;
  sx?: SxProps<Theme>;
}> = ({ contentCell, contourCell, transparencyCell, visibilityCell, testId, hover, sx }) => {
  const theme = useTheme();

  return (
    <TableRow
      sx={{
        '& td': {
          borderBottom: `1px solid ${theme.palette.divider}`,
          paddingRight: 0.5,
          paddingLeft: 1,
          paddingTop: 0,
          paddingBottom: 0
        },
        '&:hover button.locate-button': {
          opacity: 1,
          color: 'primary.main'
        },
        '& button.locate-button': { opacity: 0.1 },
        ...sx
      }}
      data-testid={testId}
      hover={hover}
    >
      <TableCell component="td" scope="row">
        {contentCell}
      </TableCell>
      <TableIconCell component="td" scope="row">
        {contourCell}
      </TableIconCell>
      <TableIconCell component="td" scope="row">
        {transparencyCell}
      </TableIconCell>
      <TableIconCell component="td" scope="row">
        {visibilityCell}
      </TableIconCell>
    </TableRow>
  );
};

const TableIconCell = styled(TableCell)`
  width: 1.5rem;
`;
